<template>
  <auth-x-widget
    ref="widget"
    :preview-mode="true"
    :loading.sync="loading"
    :widget-data="widgetData"
    :domain-data="domainData"
    :google-auth="googleAuth"
    :facebook-auth="facebookAuth"
    :field-types="fieldTypes"
    @close="setShow = false"
  />
</template>

<script>
import AuthXWidget from "@/components/Products/AuthX/Widget/AuthXWidget";

import { fieldTypes } from "@/lib/utils";

export default {
  name: "AuthXWidgetPreview",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    appData: {
      type: Object,
      default() {
        return {};
      }
    },
    appCode: {
      type: String,
      required: true
    }
  },
  components: {
    AuthXWidget
  },
  data() {
    return {
      loading: true,
      widgetData: {},
      domainData: {
        appCode: "",
        referer: "",
        refererRedirectUrl: ""
      },
      googleAuth: 0,
      facebookAuth: 0,
      fieldTypes: {}
    };
  },

  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },

  created() {
    this.loading = true;
    this.setAppData();
  },

  methods: {
    setAppData() {
      this.googleAuth = !!this.appData.user_auth_types.google;
      this.facebookAuth = !!this.appData.user_auth_types.facebook;

      this.setDomainData();
      this.setWidgetData();
    },
    setDomainData() {
      const { code, development } = this.appData;
      this.domainData = {
        sessionToken: "",
        appCode: code,
        referer: development && development.domain,
        refererRedirectUrl:
          development && development.oauth && development.oauth.redirect_uri
      };
    },

    setWidgetData() {
      const { name, customization } = this.appData;
      this.widgetData = {
        name,
        customization: customization && {
          company: customization.company_name,
          logo: customization.company_logo,
          colors: customization.meta_data && {
            primary: customization.meta_data.primary_color,
            secondary: customization.meta_data.secondary_color
          }
        },
        mfa: {
          signup: true,
          login: true
        },
        third_party_access: [],
        schema: {
          signup: [],
          login: []
        }
      };

      this.setSchemaData();
    },

    setSchemaData() {
      const { user_auth_types, user_data_fields } = this.appData;
      const { config } = user_auth_types && user_auth_types.password;
      const identificationFields = [
        {
          name: `user_auth_identifier_${this.labelToKey(
            config.username_label
          )}`,
          label: config.username_label,
          field_type_id: config.username_field_type_id,
          field_type: config.username_field_type,
          is_required: 1
        },
        {
          name: `user_auth_password_${this.labelToKey(config.password_label)}`,
          label: config.password_label,
          field_type_id: config.username_field_type_id,
          is_password_type: 1,
          password_validation: config.password_validation,
          field_type: {},
          is_required: 1
        }
      ];

      identificationFields.forEach(field => {
        this.widgetData.schema.signup.push(field);
        this.widgetData.schema.login.push(field);
      });

      user_data_fields.forEach(field => {
        if (!field.autofill) {
          this.widgetData.schema.signup.push(field);
        }
      });
      this.loadFieldTypes();
    },

    labelToKey(label) {
      return label.toLocaleLowerCase().replace(/ /gi, "_");
    },

    loadFieldTypes() {
      fieldTypes(this.$http, this.sessionToken)
        .then(res => {
          this.fieldTypes = res;
          this.loading = false;
        })
        .catch(err => {
          this.notification("Error", err.message, "danger");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.ra-icon--eye-off::before,
.ra-icon--eye::before {
  cursor: pointer;
}
</style>
